import{jsx as e}from"react/jsx-runtime";import{Helmet as t}from"react-helmet-async";const n=({canonical:r})=>r?e(t,{children:e("link",{rel:"canonical",href:r})}):null;export{n as MetaDataCanonical};
